import { type BuilderElement } from '@builder.io/sdk'
import { type ReactNode } from 'react'

export const ChildrenPositions = ['bottom', 'right'] as const

export interface ExpertGridProps {
  builderBlock?: any
  children?: ReactNode | BuilderElement[]
  childrenPositionDesktop?: (typeof ChildrenPositions)[number]
  backgroundColor?: string
  heading?: string
  subheading?: string
  imageSrcDesktop?: string
  imageScaleDesktop?: number
  imageRightDesktop?: number
  imageSrcMobile?: string
  imageAlt?: string
  columnsDesktop?: number
  columnsMobile?: number
  experts?: Array<{
    imageSrc?: string
    imageAlt?: string
    name?: string
    description?: string
  }>
}
